import React, { FC, useState } from 'react'
import { RadioGroup, Radio } from '@blueprintjs/core'
import { TodayFilterValues } from '../../types'
import css from './todayFilter.module.scss'

type TodayFilterPropsT = {
  onChange: (val: TodayFilterValues) => void
}

const TodayFilter: FC<TodayFilterPropsT> = ({ onChange }) => {
  const [selectedValue, setSelectedValue] = useState<TodayFilterValues>(
    TodayFilterValues.ALL_BOOKINGS
  )

  return (
    <RadioGroup
      className={css.wrapper}
      inline
      onChange={(event) => {
        const val = event.currentTarget.value as TodayFilterValues
        setSelectedValue(event.currentTarget.value as TodayFilterValues)
        onChange(val)
      }}
      selectedValue={selectedValue}
    >
      <Radio label="All Bookings" value={TodayFilterValues.ALL_BOOKINGS} />
      <Radio label="Today" value={TodayFilterValues.TODAY} />
    </RadioGroup>
  )
}

export default TodayFilter
